import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import { BRAND } from '../config';

const G = '#00C060';
const BG = '#f0f7f2';
const CARD = '#ffffff';
const BORDER = 'rgba(0, 192, 96, 0.4)';
const SHADOW = '0 2px 12px rgba(0,0,0,0.08)';

const Prizes = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [prizes, setPrizes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    if (user?.role !== 'admin' && user?.role !== 'super_admin') navigate('/dashboard');
    else loadPrizes();
  }, [user, navigate]);

  const loadPrizes = async () => {
    setLoading(true);
    try {
      const response = await api.get('/admin/prizes', { params: { brand: BRAND } });
      setPrizes(response.data);
    } catch (error) {
      setMessage({ type: 'danger', text: 'Erreur lors du chargement des lots' });
    } finally {
      setLoading(false);
    }
  };

  if (loading) return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ background: BG }}>
      <div className="spinner-border" style={{ color: G }} role="status"></div>
    </div>
  );

  return (
    <div className="min-vh-100" style={{ background: BG }}>
      <nav className="navbar navbar-dark sticky-top" style={{ background: '#0a1f0c', padding: '10px 0', borderBottom: `2px solid rgba(0,192,96,0.4)` }}>
        <div className="container d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <img src="/logo-white.png" alt="RNP" style={{ width: '46px', height: 'auto' }} />
            <div>
              <div className="fw-bold text-white" style={{ fontSize: '16px' }}>Reaktor Nature Power</div>
              <div style={{ fontSize: '11px', color: G }}>Gestion des Lots</div>
            </div>
          </div>
          <button onClick={() => navigate('/dashboard')} className="btn btn-sm"
            style={{ background: 'rgba(0,192,96,0.2)', border: `1px solid rgba(0,192,96,0.5)`, color: '#fff', fontSize: '13px' }}>
            <i className="fas fa-arrow-left me-2"></i>Dashboard
          </button>
        </div>
      </nav>

      <div className="container py-4">
        {message.text && (
          <div className={`alert alert-${message.type === 'success' ? 'success' : 'danger'} alert-dismissible fade show mb-3`} role="alert">
            {message.text}
            <button type="button" className="btn-close btn-close-white" onClick={() => setMessage({ type: '', text: '' })}></button>
          </div>
        )}

        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="fw-bold mb-1" style={{ color: '#1a3322', fontSize: '26px' }}>
              <i className="fas fa-gift me-2" style={{ color: G }}></i>Lots
            </h2>
            <p style={{ color: 'rgba(0,0,0,0.5)', margin: 0 }}>{prizes.length} lot(s) configuré(s)</p>
          </div>
        </div>

        {prizes.length === 0 ? (
          <div style={{ background: CARD, borderRadius: '16px', border: `1px solid ${BORDER}`, boxShadow: SHADOW, padding: '60px', textAlign: 'center' }}>
            <i className="fas fa-gift fa-4x mb-3 d-block" style={{ color: G, opacity: 0.4 }}></i>
            <p style={{ color: 'rgba(0,0,0,0.45)', fontSize: '15px' }}>Aucun lot configuré</p>
          </div>
        ) : (
          <div className="row g-3">
            {prizes.map((prize) => (
              <div key={prize.id} className="col-md-4 col-sm-6">
                <div style={{ background: CARD, borderRadius: '16px', border: `1px solid ${BORDER}`, boxShadow: SHADOW, padding: '22px', height: '100%' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '18px' }}>
                    <div style={{ width: '48px', height: '48px', background: prize.color ? `${prize.color}33` : 'rgba(0,192,96,0.15)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: `2px solid ${prize.color || G}` }}>
                      {prize.color ? (
                        <div style={{ width: '20px', height: '20px', borderRadius: '6px', background: prize.color }}></div>
                      ) : (
                        <i className="fas fa-gift" style={{ color: G, fontSize: '18px' }}></i>
                      )}
                    </div>
                    <div>
                      <div style={{ color: '#1a3322', fontWeight: 700, fontSize: '15px' }}>{prize.prize_label || prize.name || `Lot ${prize.id}`}</div>
                      <div style={{ color: 'rgba(0,0,0,0.45)', fontSize: '12px', fontFamily: 'monospace' }}>{prize.prize_type}</div>
                    </div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {[
                      { label: 'Probabilité', value: `${prize.probability || 0}%` },
                      { label: 'Quota journalier', value: prize.daily_quota || 'Illimité' },
                      { label: 'Ratio', value: prize.ratio_value ? `1 / ${prize.ratio_value}` : '-' },
                    ].map(row => (
                      <div key={row.label} style={{ display: 'flex', justifyContent: 'space-between', padding: '9px 12px', background: 'rgba(0,0,0,0.25)', borderRadius: '8px', border: `1px solid rgba(0,192,96,0.2)` }}>
                        <span style={{ color: 'rgba(0,0,0,0.55)', fontSize: '13px' }}>{row.label}</span>
                        <span style={{ color: '#1a3322', fontWeight: 700, fontSize: '13px' }}>{row.value}</span>
                      </div>
                    ))}
                  </div>

                  <div style={{ marginTop: '16px', textAlign: 'center' }}>
                    <span style={{
                      padding: '5px 18px', borderRadius: '20px', fontSize: '12px', fontWeight: 700,
                      background: prize.is_active ? 'rgba(0,192,96,0.15)' : 'rgba(229,57,53,0.15)',
                      color: prize.is_active ? '#00A651' : '#e53935',
                      border: `1px solid ${prize.is_active ? 'rgba(0,192,96,0.4)' : 'rgba(229,57,53,0.4)'}`
                    }}>
                      <i className={`fas fa-${prize.is_active ? 'check-circle' : 'times-circle'} me-1`}></i>
                      {prize.is_active ? 'Actif' : 'Inactif'}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Prizes;
